import { render } from "./footer.vue?vue&type=template&id=1e75500f&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=1e75500f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Eric\\Desktop\\WEB\\apichu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e75500f"]])

export default __exports__